import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface IProps {
    id?: string;
    type: "button" | "reset" | "submit";
    disabled?: boolean;
    icon?: IconProp;
    iconPos?: "before" | "after";
    label: string;
    className?: string;
    formId?: string;
    color: "bg-ecq-secondary" | "bg-ecq-primary" | "bg-ecq-fourth" | "light" | "bg-ecq-third" | "link";
    hoverTitle?: string;
    hoverOpacity?: boolean;
    onClickHandler?: () => void;
}

class BaseButton extends React.Component<IProps> {
    private getVariant = ():
        | "bg-ecq-secondary"
        | "bg-ecq-primary"
        | "bg-ecq-fourth"
        | "light"
        | "bg-ecq-third"
        | "link" => {
        switch (this.props.color) {
            case "bg-ecq-secondary":
                return "bg-ecq-secondary";
            case "bg-ecq-primary":
                return "bg-ecq-primary";
            case "bg-ecq-fourth":
                return "bg-ecq-fourth";
            case "light":
                return "light";
            case "bg-ecq-third":
                return "bg-ecq-third";
            case "link":
                return "link";
        }
    };

    private getColor = (): string => {
        switch (this.props.color) {
            case "bg-ecq-secondary":
                return "bg-ecq-secondary text-ecq-primary";
            case "bg-ecq-primary":
                return "bg-ecq-primary text-light";
            case "light":
                return "text-ecq-primary";
            case "bg-ecq-fourth":
                return "bg-ecq-fourth text-light";
            case "bg-ecq-third":
                return "bg-ecq-third";
            case "link":
                return "";
        }
    };

    public render(): JSX.Element {
        const {
            id,
            type,
            disabled,
            icon,
            iconPos,
            label,
            className,
            hoverTitle,
            hoverOpacity,
            formId,
            onClickHandler,
        } = this.props;

        return (
            <Button
                id={id}
                className={[
                    "font-weight-bold",
                    this.getColor(),
                    hoverOpacity ? "opacity-75" : "",
                    className ? className : "",
                ].join(" ")}
                type={type}
                variant={this.getVariant()}
                form={formId ? formId : undefined}
                disabled={disabled}
                onClick={onClickHandler}
                title={hoverTitle}
            >
                {icon && iconPos !== "after" ? <FontAwesomeIcon className={label ? "mr-2" : ""} icon={icon} /> : null}
                {label}
                {icon && iconPos === "after" ? <FontAwesomeIcon className={label ? "ml-2" : ""} icon={icon} /> : null}
            </Button>
        );
    }
}

export { BaseButton as Unconnected };
export default BaseButton;
